import { Card, Form } from "react-bootstrap";
import React from "react";

class AccountForm extends React.Component {
  state = {
    checked: false,
  };

  onChange = (onBlur, data, e) => {
    const name = e.target.name;
    const value = e.target.value;
    onBlur({ ...data, [name]: value });
  };

  handleChange = () => {
    this.setState((prevState) => ({
      checked: !prevState.checked,
    }));
  };

  render() {
    let { data, onBlur, passwordOk, checked } = this.props;
    let { onChange, handleChange } = this;
    return (
      <Card bg="light" className="loginPage__cardSection px-0 col-lg mr-lg-3">
        <Card.Header as="h4" className="">
          Dane konta
        </Card.Header>
        <Card.Body className="">
          <Form.Group controlId="formGroupEmail">
            <Form.Control
              name="email"
              type="email"
              placeholder="Email"
              required
              onChange={(e) => onChange(onBlur, data, e)}
              className="loginPage__input"
              maxLength="60"
            />
            <Form.Control.Feedback type="invalid">
              Podaj właściwy email
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId="formGroupUsername">
            <Form.Control
              name="username"
              type="text"
              placeholder="Nazwa użytkownika"
              onChange={(e) => onChange(onBlur, data, e, true)}
              required
              minLength="6"
              maxLength="30"
              pattern="^[\wa-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ_]{6,30}$"
            />
            {!this.props.isAdmin ? (
              <Form.Text className="text-muted">
                Nazwa użytkownika będzie widoczna dla innych użytkowników przy
                Twoich komentarzach. Twoje imię i nazwisko są widoczne tylko dla
                pracowników i pracodawców.
              </Form.Text>
            ) : null}

            <Form.Control.Feedback type="invalid">
              Minimalna liczba znaków: 6. Nazwa użytkownika może zawierać tylko
              cyfry, litery oraz znak _
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId="formGroupPassword">
            <Form.Control
              name="password"
              type={this.state.checked ? "text" : "password"}
              placeholder="Hasło (min. 8 znaków)"
              onChange={(e) => onChange(onBlur, data, e)}
              required
              minLength="8"
              maxLength="128"
              pattern="^(?=.*[a-ząćęłńóśźż])(?=.*[A-ZĄĆĘŁŃÓŚŹŻ])(?=.*\d)(?=.*[!@#$%^&*])[ĄĆĘŁŃÓŚŹŻA-Ząćęłńóśźża-z\d!@#$%^&*]{8,}$"
            />

            <Form.Control.Feedback type="invalid">
              Błędne hasło.
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId="formGroupPasswordRepeat">
            <Form.Control
              name="passwordR"
              type={this.state.checked ? "text" : "password"}
              placeholder="Powtórz hasło"
              onChange={(e) => onChange(onBlur, data, e)}
              required
              minLength="8"
              maxLength="128"
              pattern="^(?=.*[a-ząćęłńóśźż])(?=.*[A-ZĄĆĘŁŃÓŚŹŻ])(?=.*\d)(?=.*[!@#$%^&*])[ĄĆĘŁŃÓŚŹŻA-Ząćęłńóśźża-z\d!@#$%^&*]{8,}$"
            />
            <Form.Control.Feedback type="invalid">
              Błędne hasło.
            </Form.Control.Feedback>
            {checked && !passwordOk && (
              <small className="text-danger">Hasła muszą się zgadzać.</small>
            )}
            <Form.Text className="text-muted">
              Hasło powinno zawierać co najmniej 8 znaków, w tym małą literę,
              dużą literę, cyfrę oraz znak specjalny: !@#$%^&*. Hasło nie może
              zawierać spacji.
            </Form.Text>
          </Form.Group>
          <Form.Group controlId="passwordCheck">
            <Form.Check
              type="checkbox"
              checked={this.state.checked}
              onChange={handleChange}
              label={"Pokaż hasło"}
            />
          </Form.Group>
        </Card.Body>
      </Card>
    );
  }
}

export default AccountForm;
